import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ModalBaseStyles, ModalHeader } from "../../Common/styles/modal";
import { errorToastMessage } from "../../../utils/toast";
import http from "../../../utils/http";
import { SurveyBySlugRoot } from "../../../types/SurveyBySlug.types";
import httpSurvey from "../../../utils/httpSurvey";

type Props = {
  openModal: boolean;
  closeModal: () => void;
  surveyId?: string;
  surveySlug?: string;
};
const PrintModal = ({ openModal, closeModal, surveyId, surveySlug }: Props) => {
  const { id: studyId, participantId } = useParams();
  const [loading, setLoading] = useState(true);
  const [phases, setPhases] = useState<any>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let res;
        if (surveyId) {
          res = await http.get(
            `/study/${studyId}/survey-responses/${surveyId}?participantId=${participantId}`
          );
        } else if (surveySlug) {
          res = await httpSurvey.get<SurveyBySlugRoot>(`/survey/${surveySlug}`);
        }
        let phasesList: any[] = [];

        res?.data?.data.package.surveyLinks.forEach((link: any) => {
          if (link.phase) {
            const phaseForms = link.phase.phaseForms
              .map((phaseForm: any) => ({
                id: phaseForm.form.id,
                name: phaseForm.form.name,
                position: phaseForm.position,
              }))
              .sort((a: any, b: any) => a.position - b.position);

            phasesList.push({
              id: link.phase.id,
              name: link.phase.name,
              position: link.position,
              phaseForms,
            });
          }
        });

        phasesList.sort((a, b) => a.position - b.position);

        setPhases(phasesList || []);
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading, surveyId, participantId, studyId, surveySlug]);

  const printForm = (formId?: string) => {
    let path;

    if (surveyId) {
      path = `/print/response?studyId=${studyId}&participantId=${participantId}&surveyAssignmentId=${surveyId}`;
    } else if (surveySlug) {
      path = `/print/response?surveySlug=${surveySlug}`;
    }

    if (formId) {
      path += `&formId=${formId}`;
    }

    window.open(path, "_blank");
  };

  return (
    <Modal open={openModal} onClose={closeModal}>
      <Box sx={ModalBaseStyles}>
        <ModalHeader title="Print Forms" onCloseClick={closeModal} />
        {!loading ? (
          <>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" onClick={() => printForm()}>
                Print all
              </Button>
            </Box>
            {phases.length ? (
              phases.map((phase: any) => (
                <Box key={phase?.id}>
                  <Typography variant="h6">{phase?.name}</Typography>

                  {phase?.phaseForms?.map((form: any) => (
                    <Box
                      key={form?.id}
                      sx={{ display: "flex", alignItems: "center", mb: 1 }}
                    >
                      <Typography variant="subtitle1">{form?.name}</Typography>
                      <Box sx={{ ml: "auto" }}>
                        <Button
                          variant="outlined"
                          onClick={() => printForm(form?.id)}
                        >
                          Print
                        </Button>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))
            ) : (
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle1" color="gray">
                  No forms found
                </Typography>
              </Box>
            )}
          </>
        ) : (
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default PrintModal;
